var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2kr1yykbka",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.286275 0 0 0 0 0.317647 0 0 0 0 0.443137 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#F9F9F9",
    transform: "translate(-619.000000, -349.000000) translate(340.000000, 336.000000) translate(279.561271, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    rx: 5.317
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#2kr1yykbka)",
    transform: "translate(-619.000000, -349.000000) translate(340.000000, 336.000000) translate(279.561271, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8288A2",
    d: "M3.11 8.136l-1.062-1.14c-.348-.34-.348-.893.001-1.234l4.357-4.273c.348-.341.348-.894-.002-1.234-.35-.34-.915-.34-1.264.001L.784 4.528C-.26 5.55-.26 7.21.784 8.23l1.061 1.139c.175.17.404.256.633.256.229 0 .457-.085.631-.255.35-.34.35-.893.002-1.234z",
    transform: "translate(10.416667, 10.500000) scale(1, -1) rotate(90.000000) translate(-10.416667, -10.500000) translate(7.083333, 5.687500)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.e1b331f80c6356e3207277ad64909dd0.svg";
export { ForwardRef as ReactComponent };